function getScrollHeight(elm) {
  var savedValue = elm.value;
  elm.value = '';
  elm._baseScrollHeight = elm.scrollHeight;
  elm.value = savedValue;
}

function onExpandableTextareaInput({ target:elm }) {
  // make sure the input event originated from a textarea and it's desired to be auto-expandable
  if(!elm.nodeName === 'TEXTAREA') return;

  var minRows = elm.getAttribute('data-min-rows')|1, rows;
  !elm._baseScrollHeight && getScrollHeight(elm);

  elm.rows = minRows;
  rows = Math.ceil((elm.scrollHeight - elm._baseScrollHeight) / 21 / 1.45); // textarea font size & line-height
  elm.rows = minRows + rows;
}


// global delegated event listener
document.addEventListener('input', onExpandableTextareaInput);
